import ConversionEvent from './src/index.vue';

ConversionEvent.install = function(Vue) {
  Vue.component(ConversionEvent.name, ConversionEvent);
};

export default ConversionEvent;
